import Page from "./page/ContractPage";
import Header from "./header/ContractHeader";

export default { Page, Header };
